import { render, staticRenderFns } from "./categoryEdit.vue?vue&type=template&id=15fd3c6e"
import script from "./categoryEdit.vue?vue&type=script&lang=ts"
export * from "./categoryEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports